import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/validacoes/procedimentoOcupacao`

    return {

        post: async params => {
            return (await repository.post(`${baseUrl}`, params)).data
        }
    }
}